import { render, staticRenderFns } from "./BankHolidays.vue?vue&type=template&id=f07e351a&scoped=true"
import script from "./BankHolidays.vue?vue&type=script&lang=js"
export * from "./BankHolidays.vue?vue&type=script&lang=js"
import style0 from "./BankHolidays.vue?vue&type=style&index=0&id=f07e351a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07e351a",
  null
  
)

export default component.exports